<template> <!-- OK -->
  <div class="group-games">
    <h2>Jogos da Etapa</h2>
    <div class="sort-controls">
      <span>Ordenar por:</span>
      <button @click="sortMode = 'date'" :class="{ active: sortMode === 'date' }">Data</button>
      <button @click="sortMode = 'group'" :class="{ active: sortMode === 'group' }">Grupo</button>
    </div>
    <div class="games-table">
      <table>
        <thead>
          <tr>
            <th>Jogador 1</th>
            <th>Jogador 2</th>
            <th>Grupo</th>
            <th>Set 1</th>
            <th>Set 2</th>
            <th>Set 3</th>
            <th>Status</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="game in gamesWithWinner" :key="game.id">
            <td :class="{'winner-highlight': game.winner === game.player1.User.fullName}">
              {{ game.player1.User.fullName }}
            </td>
            <td :class="{'winner-highlight': game.winner === game.player2.User.fullName}">
              {{ game.player2.User.fullName }}
            </td>
            <td>{{game.groupInfo.name}}</td>
            <td v-if="game.status === 'Realizado' || game.status === 'WO'" >{{ game.set1Player1 }} X {{ game.set1Player2 }}</td>
            <td v-else>--</td>
            <td v-if="game.status === 'Realizado' || game.status === 'WO'">{{ game.set2Player1 }} X {{ game.set2Player2 }}</td>
            <td v-else>--</td>
            <td v-if="game.set3Player1 !== 0 || game.set3Player2 !== 0">{{ game.set3Player1 }} X {{ game.set3Player2 }}</td>
            <td v-else>--</td>
            <td>{{ game.status }}</td>
            <td>{{ formatDate(game.updatedAt) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GamesTable',
  props: {
    games: Array
  },
  data() {
    return {
      sortMode: 'date',
    }
  },
  computed: {
    sortedGames() {
      const sorted = [...this.games];
      if (this.sortMode === 'date') {
        return sorted.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      }
      if (this.sortMode === 'group') {
        return sorted.sort((a, b) => {
          const groupA = a.groupInfo.name;
          const groupB = b.groupInfo.name;
          return groupA.localeCompare(groupB, undefined, { numeric: true });
        });
      }
      return sorted;
    },
    gamesWithWinner(){
      return this.sortedGames.map((game) => {
        let player1Wins = 0
        let player2Wins = 0

        if(game.set1Player1 > game.set1Player2){
          player1Wins += 1
        }else{
          player2Wins += 1
        }

        if(game.set2Player1 > game.set2Player2){
          player1Wins += 1
        }else{
          player2Wins += 1
        }

        if(game.set3Player1 > game.set3Player2){
          player1Wins += 1
        }else{
          player2Wins += 1
        }

        let winner = null;

        if(player1Wins > player2Wins){
          winner = game.player1.User.fullName
        } else{
          winner = game.player2.User.fullName
        }

        return { ...game, winner}
      })
    },
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      })
    }
  }
};
</script>

<style scoped>
.group-games{
  width: 90%;
  max-width: 1200px;
  padding: 1rem;
  background-color: #FFF;
  color: black;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.group-games h2{
  text-align: center;
  margin-bottom: 1rem;
  font-size: 2rem;
  text-transform: uppercase;
  border-bottom: 1px solid black;
  padding-bottom: 0.5rem;
}

.group-dropdown{
  position: absolute;
  background-color: white;
  color: black;
  border: 1px solid #ddd;
  z-index: 100;
  width: 150px;
  max-height: 150px;
  overflow-y: scroll;
  margin: 1rem auto;
  text-align: left;
  left: 44.5%;
}

.group-dropdown ul{
  list-style: none;
  padding: 0;
  margin: 0;
}

.group-dropdown li{
  padding: 0.5rem;
  cursor: pointer;
}

.group-dropdown li:hover{
  background-color: #DDD;
}

.dropdown-button {
  display: block;
  margin: auto;
  background-color: #0056B3;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
}

.dropdown-button:hover {
  background-color: #007BFF;
}

.games-table{
  width: 100%;
  margin-top: 1rem;
  overflow-x: auto;
}

.games-table table {
  width: 100%;
  border-collapse: collapse;
}

.games-table th,
.games-table td{
  border: 1px solid #DDD;
  padding: 0.5rem;
  text-align: center;
}

.games-table th{
  background-color: #0056B3;
  color: white;
}

.winner-highlight{
  font-weight: bold;
  background-color: #18a618;
  color: white;
}

.sort-controls {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
  align-items: center;
}

.sort-controls button {
  padding: 0.5rem 1rem;
  border: none;
  background-color: #ccc;
  border-radius: 5px;
  cursor: pointer;
}

.sort-controls button.active {
  background-color: #0056B3;
  color: white;
}

</style>
